import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipComponent',
  props: {
  name: { type: String, default: "tooltip" },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const tooltipComponentDropdownContentRef = ref<HTMLDivElement>();
const el = ref();
const placeholder = ref();
const dropdown = ref();
const tooltipOpen = ref();
const dropdownContent = ref<HTMLDivElement>();

function handleDropdownPosition() {
  const screenPadding = 16;

  const placeholderRect = placeholder.value?.getBoundingClientRect();
  const dropdownRect = dropdown.value?.getBoundingClientRect();

  const dropdownRightX = dropdownRect.x + dropdownRect.width;
  const placeholderRightX = placeholderRect.x + placeholderRect.width;

  console.log("handleDropdownPosition", {
    dropdownRef: dropdown.value,
    elRef: el.value,
    placeholderRef: placeholder.value,
    placeholderRect,
    dropdownRect,
    dropdownRightX,
    placeholderRightX,
  });

  if (window.innerWidth > 576) {
    if (dropdownRect.x < 0) {
      (dropdown.value as HTMLElement).style.left = "0";
      (dropdown.value as HTMLElement).style.right = "auto";
      (dropdown.value as HTMLElement).style.transform = `translateX(${
        -placeholderRect.x + screenPadding
      }px)`;
    } else if (dropdownRightX > window.outerWidth) {
      (dropdown.value as HTMLElement).style.left = "auto";
      (dropdown.value as HTMLElement).style.right = "0";
      (dropdown.value as HTMLElement).style.transform = `translateX(${
        window.outerWidth - placeholderRightX - screenPadding
      }px)`;
    }
  }

  if (el.value?.classList.contains("xs-bottom-left")) {
    // (dropdownContent.value as HTMLElement).style.right;
  }
}

function toggle() {
  if (tooltipOpen.value === true) {
    close();
  } else {
    open();
  }
}

function open() {
  tooltipOpen.value = true;
  handleDropdownPosition();
}

function close() {
  tooltipOpen.value = false;
}

function handleClickOutside(event: any) {
  if (!(el.value as HTMLElement).contains(event.target)) {
    tooltipOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});
onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

__expose({
  el,
  tooltipComponentDropdownContentRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "el",
    ref: el,
    class: ["tooltip-component", { open: tooltipOpen.value }]
  }, _ctx.$attrs), [
    _createElementVNode("div", {
      class: "tooltip-component__label",
      "aria-describedby": "tooltip-demo-content",
      "data-tooltip-placeholder": "",
      ref_key: "placeholder",
      ref: placeholder,
      "on:mouseOver": _withModifiers(handleDropdownPosition, ["prevent"]),
      "on:touchStart": toggle,
      onClick: _withModifiers(toggle, ["stop"])
    }, [
      _renderSlot(_ctx.$slots, "toggle")
    ], 544),
    _createElementVNode("div", {
      class: "tooltip-component-dropdown",
      "data-tooltip-dropdown": "",
      ref_key: "dropdown",
      ref: dropdown
    }, [
      _createElementVNode("div", {
        role: "tooltip",
        id: "tooltip-demo-content",
        class: "tooltip-component-dropdown__content",
        ref_key: "dropdownContent",
        ref: dropdownContent
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 512)
  ], 16))
}
}

})